export const getAccessLink = async (
  host: string,
  email: string,
  returnUrl: string,
  onSuccess: Function,
  onError: Function,
  onUserNotFound: Function
) => {
  const queryString = returnUrl
    ? `?returnUrl=${encodeURIComponent(returnUrl)}`
    : ''

  const response = await fetch(`/_/access_link/${email}${queryString}`, {
    headers: {
      'X-Taylora-Host': host,
    },
  })

  if (response.ok) {
    onSuccess()
    return true
  } else {
    if (response.status === 404) {
      onUserNotFound()
    } else {
      onError()
    }
  }

  return false
}
